import $ from 'jquery';
import { directiveSettings } from '../../utils/parse';
import { getHeight, getScrollTop, onScroll } from '../../utils/window';

/**
 * Fades an element out or in, the closer or farther it moves to or from the top of the window.
 * Start fade-out once an element reaches 25% of the window height: <div sw-fade="0.25"></div>
 * Start fade-out at 75% of the window height, and finish at 25%, based on the top position of the element:
 * <div sw-fade='{"scroll": 0.5, "position": "top", "offset": 0.25}'></div>
 *
 * @param context
 */
export default function fadeDirective(context=document.body) {
    const $context = $(context);

    $context.find('[sw-fade]').each(function() {
        const $element = $(this);
        const json = $element.attr('sw-fade');
        const settings = directiveSettings(json, {
            scroll: 0.25,
            position: 'middle',
            offset: 0,
        }, 'scroll');

        onScroll(function() {
            const elementOffset = $element.offset().top - getHeight() * settings.offset;
            const elementHeight = $element.outerHeight();
            let elementPosition;
            switch (settings.position) {
                case 'top': elementPosition = 0; break;
                case 'bottom': elementPosition = elementHeight; break;
                default: elementPosition = elementHeight / 2; break;
            }
            const contentPos = elementOffset + elementPosition - getScrollTop();
            const fadeHeight = getHeight() * settings.scroll;
            let opacity = contentPos / fadeHeight;
            if (opacity < 0) {
                opacity = 0;
            } else if (opacity > 1) {
                opacity = 1;
            }
            if (parseFloat($element.css('opacity')) !== opacity) {
                $element.css('opacity', opacity);
            }
        });
    });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/fade.js